import React from "react";

import "./toggleButton.scss";
import FlashHover from "../../flashHover/flashHover";

export default function ToggleButton({
	label,
	className = "",
	checked,
	onClick,
	disabled,
}) {
	return (
		<button
			className={`toggleButton ${className} ${
				checked ? "checked" : "unchecked"
			}`}
			onClick={onClick}
			disabled={disabled}
			aria-label={label}
		>
			<div>
				<span id="toggle" />
				<span id="background" />
			</div>
			<FlashHover>
				<span id="label" className="h1">
					{label}
				</span>
			</FlashHover>
		</button>
	);
}
